// extracted by mini-css-extract-plugin
export var container = "_dr-0";
export var containerTopRight = "_dr-1";